import React, { useContext } from "react";
import styles from "./Chat.module.sass";
import useChatUrl from "../../hooks/useChatUrl";
import { withRouter } from "react-router";
import AppContext from "../../contexts/appContext";


function Chat(props) {
  const { callChat } = useChatUrl();
  const context = useContext(AppContext);

  if (process.env.REACT_APP_DISABLE_CHAT === 'true') {
    return null;
  }

  return (
    <>
      {!context.ibc && !props.location.pathname.includes("confirmar-oferta") && (
        <button
          id="btnChat"
          className={[styles.chat, props.detached ? styles.detached : ""].join(
            " "
          )}
          onClick={callChat}
          data-gacategory="AutoCompra-Consórcio"
          data-gatype="AutoCompra-Consórcio-Chat-Rodapé"
          data-gafunc="AutoCompra-Consórcio-Chat-Rodapé-Precisa de ajuda?"
        >
          <span className={styles.textChat}>Precisa de ajuda?</span>
          <span className={styles.subtextChat}>
            {context.ibc
              ? "Tire suas dúvidas aqui."
              : "Continue comprando pelo chat e tire suas dúvidas."}
          </span>
        </button>
      )}
    </>
  );
}

export default withRouter(Chat);
